import {
    LECTURE_TAG_ID_BL,
    LONGREAD_TAG_ID_BL,
    ABOUT_ART_TAG_ID,
    RESEARCH_CATEGORY_ID
} from "../constants/misc";
import { visualResearchTags } from "../pages/project/components/const/visualResearchTags";

const tagsWithSpecialSourcesBlocks = [
    ...visualResearchTags,
    LONGREAD_TAG_ID_BL,
    LECTURE_TAG_ID_BL,
    ABOUT_ART_TAG_ID,
]

export const getHasSpecialSourcesBlocks = (tags: string[], tagsRaw?: any[]): boolean => {

    if (!tags || tags?.length === 0) return false

    const isResearchTag = !!tagsRaw?.some(tagRaw => {
        return tagRaw.groupIds?.includes(RESEARCH_CATEGORY_ID) && tagRaw.isEducationTag
    })

    return tagsWithSpecialSourcesBlocks.some(tag => tags.includes(tag)) || isResearchTag
}
import {
    LECTURE_TAG_ID_BL,
    LONGREAD_TAG_ID_BL,
    ABOUT_ART_TAG_ID,
    RESEARCH_CATEGORY_ID
} from "../constants/misc";
import { visualResearchTags } from "../pages/project/components/const/visualResearchTags";

const tagsWithSpecialSourcesBlocks = [
    ...visualResearchTags,
    LONGREAD_TAG_ID_BL,
    LECTURE_TAG_ID_BL,
    ABOUT_ART_TAG_ID,
]

export const getHasSpecialSourcesBlocks = (tags: string[], tagsRaw?: any[]): boolean => {

    if (!tags || tags?.length === 0) return false

    const isResearchTag = !!tagsRaw?.some(tagRaw => {
        return tagRaw.groupIds?.includes(RESEARCH_CATEGORY_ID) && tagRaw.isEducationTag
    })

    return tagsWithSpecialSourcesBlocks.some(tag => tags.includes(tag)) || isResearchTag
}
